function log(event, data = {}) {
  return fetch("/ui/log", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      event,
      ...data
    })
  })
}

export default log
